import {
  PermissionsTableRow,
  PermissionTableOperation,
} from '@modules/users/types';
import { useIsUserRolesEnabled } from '@modules/workspaceSettings/hooks';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Box, Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';

interface PermissionOperationColumnCellProps {
  params: GridRenderCellParams<
    PermissionsTableRow,
    PermissionTableOperation,
    unknown
  >;
}

export const PermissionOperationColumnCell = ({
  params,
}: PermissionOperationColumnCellProps) => {
  const isUserRolesEnabled = useIsUserRolesEnabled();

  const getLabelColor = () => {
    if (params.value === PermissionTableOperation.Edit) {
      return 'info.light';
    }
    if (params.value === PermissionTableOperation.View) {
      return 'text.primary';
    }
    return 'text.secondary';
  };

  const getLabelText = () => {
    if (isUserRolesEnabled) {
      if (params.value === PermissionTableOperation.Edit) {
        return <CheckRoundedIcon color="success" />;
      }
      return <CloseRoundedIcon color="error" />;
    }

    if (params.value === PermissionTableOperation.Edit) {
      return 'Can Edit';
    }
    if (params.value === PermissionTableOperation.View) {
      return 'Can View';
    }
    return 'No Access';
  };

  return (
    <Box mx="auto">
      <Typography color={getLabelColor()} variant="body2" textAlign="center">
        {getLabelText()}
      </Typography>
    </Box>
  );
};
